import { useNavigate } from 'react-router-dom';

interface EmailCollisionModalProps {
  existingUserId: number;
  email: string;
  onClose: () => void;
}

// Feature 011 — Acceptance Scenario 1.3 / FR-020 / FR-044. Surfaces the 409
// "EMAIL_EXISTS" payload with a CTA that navigates to the User Management page
// with the matching row highlighted.
export function EmailCollisionModal({ existingUserId, email, onClose }: EmailCollisionModalProps) {
  const navigate = useNavigate();

  const handleGoToUser = () => {
    onClose();
    navigate(`/admin/users?highlight=${existingUserId}`);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      role="dialog"
      aria-modal="true"
      aria-labelledby="email-collision-title"
    >
      <div className="bg-card rounded-lg shadow-xl max-w-md w-full p-6 mx-4">
        <h2 id="email-collision-title" className="text-lg font-semibold text-ink mb-3">
          An account with this email already exists
        </h2>
        <p className="text-sm text-ink mb-6">
          The email <span className="font-mono">{email}</span> is already in use. Open the
          existing user's row to review their role and grants.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-ink bg-card border border-line-strong rounded-md hover:bg-cream"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleGoToUser}
            className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700"
          >
            Go to user
          </button>
        </div>
      </div>
    </div>
  );
}
